import { makeVar } from '@apollo/client';

interface HeaderData {
  activeModal: boolean;
}
export const headerData = makeVar<HeaderData>({ activeModal: false });
